import React, { useEffect, useState, useContext } from "react";
import { sortBy, get } from "lodash";
import { connect, useSelector } from "react-redux";
import { compose } from "redux";
import { withApollo } from "react-apollo";
import { Auth } from "aws-amplify";
import { configureAwsAppSync } from "../../utils/helpers/configureAwsAppSync";
import {loadUserInfo as loadUserInfoAction, loadUserProjects as loadUserProjectsAction} from "../user/redux/actions";
import {
  loadRoomList as loadRoomListAction,
  loadBuildingList as loadBuildingListAction,
  loadAddReasonList as loadAddReasonListAction,
} from "../booking-admin/redux/actions";
import { loadActionTypes as loadActionTypesAction } from "../../gql/redux/actions";
import styled from "styled-components";
import { signOut } from "../../utils/signout";
import { ACCESS_TOKEN_PATH, BOOKING_USER, DEFAULT_NEW_USER_NOTIFICATION_THRESHOLDS, DURATION, GROUPS_TOKEN_PATH, INSTRUMENT_REPOSITORY_ADMIN, INSTRUMENT_REPOSITORY_USER, INSTRUMENT_REPOSITORY_VIEWER, REPO_CONFIG, SYNC_PROFILE_FIELDS } from "../../constants";
import { DEFAULT_COLUMNS, DEFAULT_FILTER } from "../../constants";
import {
  LIST_DIGITAL_LAB_BOOKING_USERS,
  LIST_FILTERBOOKING_DATA_BY_SITE_NAME_AND_FILTER_ATTRIBUTES,
  LIST_CONFIGURATION_BY__MODEL_AND_CREATED_DATE_DROPDOWN,
  LP_GET_LOGGED_USER_DETAILS,
  NOTIFICATION_GET_LOGGED_USER_DETAILS,
  LP_LIST_DIGITAL_LAB_LANDING_PAGE_APPLICATIONS,
  GET_SITE_TIMEZONE,
  GET_LIST_OF_ACTION_TYPES,
  BOOKING_GET_LOGGED_USER_DETAILS,
  GET_AVAILABLE_PROJECTS,
  LIST_IR_GROUP_ADMIN_MAPPINGS,
} from "../../gql/bookingapi/queries";
import {
  loadBookingInstruments as loadBookingInstrumentsAction,
  updateSearchDropDownFilter as updateSearchDropDownFilterActions,
} from "./redux/actions";
import { emptyLastFilter, stringifyFilter } from "../../utils/store/lastFilter";
import {
  clearResetAllStartupPreferences,
  markBookEquipmentStartupResetPending,
  setBookEquipmentSessionPreferences,
} from "../../utils/store/bookingFilterPersistence";
import {
  CREATE_DIGITAL_LAB_BOOKING_USER_PROFILE,
  CREATE_DIGITAL_LAB_NOTIFICATION_USER_PROFILE,
  CONFIGURE_NOTIFICATION_THRESHOLDS,
  UPDATE_DIGITAL_LAB_NOTIFICATION_USER_PROFILE_PERSONAL_FIELDS,
  UPDATE_DIGITAL_LAB_BOOKING_USER_PROFILE_PERSONAL_FIELDS,
  UPDATE_DIGITAL_LAB_LP_USER_PROFILE_FILTER,
} from "../../gql/bookingapi/mutations";
import { loadUsers as loadUsersAction } from "../booking-users/redux/actions";
import { initialState as filterInitialState } from "../booking-instruments/booking-instruments-custom-filter/CustomFilterWrapper";
import { isEqual, pick } from "underscore";
import { getAllData} from "../../utils/helpers/fetching";
import { WidgetContext } from "../../contexts";
import { getCookieData } from "../../utils/helpers/cookie";
import { API } from "aws-amplify";
import { OwcButton, OwcProgressSpinner, OwcTypography, OwcHyperlink } from "@one/react";
import { snackbarService } from "@one/web-components/dist/index.cjs.js";
import useSecondaryAuth from "../authentication/useSecondaryAuth";
import {PRED_SITE_NAME, GRED_SITE_NAME} from "../../constants";

let hasClearedResetAllForCurrentAppLoad = false;

export const FullScreenCentered = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  margin: 0;
  width: 100vw;
  height: 100vh;
`;

const ErrorActions = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.7rem;
  margin-top: 1.5rem;
`;

class SiteError extends Error {
  constructor(message) {
    super(message);
    this.name = "SiteError";
  }
}

class UnauthorizedError extends Error {
  constructor(message) {
    super(message);
    this.name = "UnauthorizedError";
  }
}

class EmailChangedError extends Error {
  constructor(message) {
    super(message);
    this.name = "EmailChangedError";
  }
}

const refreshSessionSafely = async (errorMessage) => {
  try {
    await Auth.currentSession();
  } catch (sessionError) {
    console.warn(errorMessage, sessionError);
  }
};

const scheduleProjectsRetry = ({ client, user, loadUserProjects }) => {
  // First getUserProjects call may timeout while BE is still fetching and caching all RedPanda projects, so we retry once to read projects from cache again.
  setTimeout(async () => {
    try {
      const retryProjects = await getUserProjects({ client, user });
      if (retryProjects) {
        loadUserProjects(retryProjects);
      }
    } catch (e) {
      console.warn("Background retry for RedPanda projects failed:", e?.message || e);
    }
  }, 30000);
};

export const resolveSearchPreferences = (searchPreference) => {
  if (!searchPreference) {
    return null;
  }

  const parsedSearchPreference = JSON.parse(searchPreference);
  const searchPreferencesSource = parsedSearchPreference?.searchPreference || parsedSearchPreference;
  const searchPreferances = sortBy(searchPreferencesSource, "title");

  const searchCookieQuery = getCookieData("searchQuery");
  if (searchCookieQuery) {
    searchPreferances.forEach((item) => {
      if (item.coloumn === "equipmentId" || item.coloumn === "serialNumber") {
        item.checked = true;
      }
    });
  }

  return searchPreferances;
};

const CONDITIONAL_REQUEST_FAILED_ERROR = "GraphQL error: The conditional request failed";
const EMAIL_CHANGED_MESSAGE =
  "Your email has changed, please wait a minute and login again for the change to take effect";

const renderErrorMessage = ({ error, infoUrl, openGridHomeInNewTab, openInfoPageInNewTab }) => {
  if (error?.name === "SiteError") {
    return (
      <OwcTypography variant="title6" data-testid="message-error" gutterBottom>
        {"You do not have site location assigned. Go to "}
        <OwcHyperlink
          href={process.env.REACT_APP_LP_GRAPHQL_ENDPOINT_CLOUDFRONT}
          target="_blank"
          rel="noopener noreferrer"
          onClick={(event) => {
            event.preventDefault();
            openGridHomeInNewTab();
          }}
        >
          GRID Home
        </OwcHyperlink>
        {" to configure it, then refresh this page."}
      </OwcTypography>
    );
  }

  if (error?.name === "UnauthorizedError") {
    return (
      <OwcTypography variant="title6" data-testid="message-error" gutterBottom>
        {"You do not have permission, please request access in CIDM and then login again. See "}
        <OwcHyperlink
          href={infoUrl}
          target="_blank"
          rel="noopener noreferrer"
          onClick={(event) => {
            event.preventDefault();
            openInfoPageInNewTab();
          }}
        >
          gSite
        </OwcHyperlink>
        {" for details."}
      </OwcTypography>
    );
  }

  if (error?.name === "EmailChangedError") {
    return (
      <OwcTypography variant="title6" data-testid="message-error" gutterBottom>
        {"Your email has changed, please wait a minute and login again for the change to take effect"}
      </OwcTypography>
    );
  }

  return (
    <OwcTypography variant="title6" data-testid="message-error" gutterBottom>
      {error?.message ? error?.message : "Unexpected error has occurred"}
    </OwcTypography>
  );
};

const stripPhoneNumber = (phoneNumber) => phoneNumber?.replace(/[^+\d]/gi, "") ?? "";

const getIrRole = (access_groups) => {
  if (access_groups.includes(INSTRUMENT_REPOSITORY_ADMIN)) { return "Admin"; }
  if (access_groups.includes(INSTRUMENT_REPOSITORY_USER)) { return "User"; }
  if (access_groups.includes(INSTRUMENT_REPOSITORY_VIEWER)) { return "Viewer"; }
  return "Viewer";
};

export const checkRoleAndGetUserEmail = async (theAuth, required_group = BOOKING_USER) => {
  const currentAuthenticatedUser = await theAuth.currentAuthenticatedUser();
  const access_groups = get(currentAuthenticatedUser, GROUPS_TOKEN_PATH);
  if (!Array.isArray(access_groups) || !access_groups.includes(required_group)) {
    throw new UnauthorizedError("You do not have permission, please request access in CIDM and then login again. See gSite for details.");
  }
  const syncFields = pick(get(currentAuthenticatedUser, ACCESS_TOKEN_PATH), Object.values(SYNC_PROFILE_FIELDS));
  const email = get(currentAuthenticatedUser, "attributes.email");

  if (syncFields?.[SYNC_PROFILE_FIELDS.phone]) {
    syncFields[SYNC_PROFILE_FIELDS.phone] = stripPhoneNumber(syncFields?.[SYNC_PROFILE_FIELDS.phone]);
  }
  const irRole = getIrRole(access_groups);
  return { email, roles: access_groups, irRole, ...syncFields };
};

export const getBookingAddReason = async ({ client }) => {
  const { items: bookingAddReason } = await getAllData({
    client,
    query: LIST_CONFIGURATION_BY__MODEL_AND_CREATED_DATE_DROPDOWN,
    fetchPolicy: "no-cache",
    dataPath: ["data", "configurationByModelAndText"],
    variables: {
      limit: 500,
    },
    drillData: true,
  });

  return {
    bookingAddReason,
  };
};

export const getRoomList = async ({ client, siteName }) => {
  const { items } = await getAllData({
    client,
    query: LIST_FILTERBOOKING_DATA_BY_SITE_NAME_AND_FILTER_ATTRIBUTES,
    drillData: true,
    fetchPolicy: "no-cache",
    variables: {
      siteName,
      limit: 500,
      nextToken: null,
      filterAttribute: { eq: "room" },
    },
    dataPath: ["data", "listFilterBookingDataBySiteNameAndFilterAttributes"],
  });

  const roomList = items.map((item) => item.filterValue);
  return { roomList };
};

export const getBuildingList = async ({ client, siteName }) => {
  const { items } = await getAllData({
    client,
    query: LIST_FILTERBOOKING_DATA_BY_SITE_NAME_AND_FILTER_ATTRIBUTES,
    drillData: true,
    fetchPolicy: "no-cache",
    variables: {
      siteName,
      limit: 500,
      nextToken: null,
      filterAttribute: { eq: "buildingLocation" },
    },
    dataPath: ["data", "listFilterBookingDataBySiteNameAndFilterAttributes"],
  });

  const buildingList = items.map((item) => item.filterValue);
  return { buildingList };
};
export const getBookingUsers = async ({ client, query_bookingUsers }) => {
  const { items: bookingUsers = [] } = await getAllData({
    client,
    query: query_bookingUsers,
    fetchPolicy: "no-cache",
    dataPath: ["data", "listDigitalLabBookingUsers"],
    drillData: true,
    variables: {
      limit: 1000,
    },
  });

  return {
    bookingUsers,
  };
};
export const updateProfileFields = async ({ client, email, user, ...syncFields }) => {
  const syncKeys = Object.keys(SYNC_PROFILE_FIELDS);
  const profileEmail = user?.email || email;
  const profileObj = syncKeys.reduce(
    (acc, currKey) => ({
      ...acc,
      [currKey]: syncFields?.[SYNC_PROFILE_FIELDS?.[currKey]] ?? "",
    }),
    {}
  );
  if (!user) {
    return profileObj;
  }
  const shouldUpdate = !isEqual(pick(user, syncKeys), {
    ...profileObj,
    site: profileObj?.site || user.site,
  });
  if (!shouldUpdate) return user;
  const {
    data: { updateDigitalLabBookingUserProfile: updatedUser },
  } = await client.mutate({
    mutation: UPDATE_DIGITAL_LAB_BOOKING_USER_PROFILE_PERSONAL_FIELDS,
    fetchPolicy: "no-cache",
    variables: {
      id: user?.id,
      email: profileEmail,
      lastFilter: user?.lastFilter,
      ...profileObj,
      site: profileObj?.site || user?.site,
    },
  });
  return updatedUser;
};

export const updateLPState = async ({ client, user }) => {
  let lastFilterData = {};
  if (user?.lastFilter) {
    lastFilterData = JSON.parse(decodeURI(user?.lastFilter));
  }
  lastFilterData.selectedGroup = {
    id: "",
    name: "Applications",
    type: "allApplications",
  };
  lastFilterData = encodeURI(JSON.stringify(lastFilterData));
  const LP_config = {
    aws_appsync_graphqlEndpoint: process.env.REACT_APP_LP_AWS_GRAPHQL_ENDPOINT,
  };
  configureAwsAppSync(LP_config);
  const { updatedDigitalLabLandingPageUserProfile } = await API.graphql({
    query: UPDATE_DIGITAL_LAB_LP_USER_PROFILE_FILTER,
    client,
    variables: {
      id: user?.id,
      email: user?.email,
      lastFilter: lastFilterData,
    },
  });
  return {
    updatedDigitalLabLandingPageUserProfile,
  };
};

export const getLPUserDetails = async ({ client }) => {
  const LP_config = {
    aws_appsync_graphqlEndpoint: process.env.REACT_APP_LP_AWS_GRAPHQL_ENDPOINT,
  };

  configureAwsAppSync(LP_config);
  const userInfo = await API.graphql({
    query: LP_GET_LOGGED_USER_DETAILS,
    client,
  });

  return get(userInfo, "data.getLoggedInUserDetails.items[0]");
};

const getNotificationAppSyncConfig = () => {
  const getNotificationEndpointFromLP = () => {
    const lpEndpoint = process.env.REACT_APP_LP_AWS_GRAPHQL_ENDPOINT;
    if (!lpEndpoint) {
      return null;
    }

    try {
      const parsedEndpoint = new URL(lpEndpoint);
      parsedEndpoint.hostname = parsedEndpoint.hostname
        .replace("lp-eu.", "notifications-eu.")
        .replace("lp-us.", "notifications-us.");
      parsedEndpoint.pathname = "/graphql";
      parsedEndpoint.search = "";
      parsedEndpoint.hash = "";
      return parsedEndpoint.toString();
    } catch (_err) {
      return null;
    }
  };

  const notificationEndpoint = process.env.REACT_APP_NOTIFICATION_AWS_GRAPHQL_ENDPOINT || getNotificationEndpointFromLP();
  if (!notificationEndpoint) {
    return null;
  }
  return {
    aws_appsync_graphqlEndpoint: notificationEndpoint,
  };
};

export const syncNotificationUserProfile = async ({ client, email, user, ...syncFields }) => {
  const notificationConfig = getNotificationAppSyncConfig();
  if (!notificationConfig) {
    return;
  }

  const bookingConfig = {
    aws_appsync_graphqlEndpoint: process.env.REACT_APP_AWS_GRAPHQL_ENDPOINT,
  };

  await configureAwsAppSync(notificationConfig);
  try {
    const result = await API.graphql({
      query: NOTIFICATION_GET_LOGGED_USER_DETAILS,
      client,
    });

    const notificationUser = get(result, "data.getLoggedInUserDetails.items[0]");
    const syncKeys = Object.keys(SYNC_PROFILE_FIELDS);
    const profileObj = syncKeys.reduce(
      (acc, currKey) => ({
        ...acc,
        [currKey]: syncFields?.[SYNC_PROFILE_FIELDS?.[currKey]] ?? "",
      }),
      {}
    );

    const profilePayload = {
      ...profileObj,
      site: profileObj?.site || notificationUser?.site || user?.site,
    };

    if (notificationUser?.id) {
      const shouldUpdate = !isEqual(pick(notificationUser, syncKeys), profilePayload);
      if (!shouldUpdate) {
        return;
      }

      await API.graphql({
        query: UPDATE_DIGITAL_LAB_NOTIFICATION_USER_PROFILE_PERSONAL_FIELDS,
        client,
        variables: {
          id: notificationUser?.id,
          email,
          ...profilePayload,
        },
      });
      return;
    }

    await API.graphql({
      query: CREATE_DIGITAL_LAB_NOTIFICATION_USER_PROFILE,
      client,
      variables: {
        email,
        ...profilePayload,
      },
    });

    try {
      await API.graphql({
        query: CONFIGURE_NOTIFICATION_THRESHOLDS,
        client,
        variables: {
          input: DEFAULT_NEW_USER_NOTIFICATION_THRESHOLDS,
        },
      });
    } catch (seedError) {
      console.warn("Failed to seed default notification thresholds for new user:", seedError);
    }
  } finally {
    if (bookingConfig.aws_appsync_graphqlEndpoint) {
      await configureAwsAppSync(bookingConfig);
    }
  }
};
export const getLPAllApp = async ({ client }) => {
  const LP_config = {
    aws_appsync_graphqlEndpoint: process.env.REACT_APP_LP_AWS_GRAPHQL_ENDPOINT,
  };

  configureAwsAppSync(LP_config);
  const allApps = await API.graphql({
    query: LP_LIST_DIGITAL_LAB_LANDING_PAGE_APPLICATIONS,
    client,
  });

  return get(allApps, "data.listDigitalLabLandingPageApplications");
};
export const getUserProjects = async ({ client, user }) => {
  const jwtToken = localStorage.getItem("secondaryAuthAccessToken");
  if (!jwtToken) {
    return null;
  }

  try {
    const result = await client.query({
      query: GET_AVAILABLE_PROJECTS,
      fetchPolicy: "network-only",
      variables: {
        userId: user.id || user.userId || user.user,
        email: user.email,
        token: jwtToken,
      },
    });
    const projects = result?.data?.getAvailableProjectsFromRedPanda;

    if (!Array.isArray(projects)) {
      return null;
    }

    return projects;
  } catch (error) {
    return null;
  }
};
export const getUserDetails = async ({ client, email: incomingEmail, ...syncFields }) => {
  const result = await client.query({
    query: BOOKING_GET_LOGGED_USER_DETAILS,
    fetchPolicy: "no-cache",
  });

  const email = incomingEmail;
  const user = get(result, "data.getLoggedInUserDetails.items[0]");
  const profileEmail = user?.email || email;

  const hasEmailChanged = Boolean(user?.email && incomingEmail && user.email !== incomingEmail);
  const hasStableProfileId = Boolean(user?.id);
  if (hasEmailChanged && !hasStableProfileId) {
    throw new EmailChangedError(EMAIL_CHANGED_MESSAGE);
  }


  // Resolve site from LP profile as source of truth when token claim is stale after site switch.
  let resolvedSyncFields = { ...syncFields };
  try {
    const lpUser = await getLPUserDetails({ client });
    if (lpUser?.site && lpUser.site !== resolvedSyncFields?.[SYNC_PROFILE_FIELDS.site]) {
      resolvedSyncFields = { ...resolvedSyncFields, [SYNC_PROFILE_FIELDS.site]: lpUser.site };
    }
  } catch (lpErr) {
    console.warn("Could not read site from LP profile:", lpErr);
  }

  const resolvedSite = resolvedSyncFields?.[SYNC_PROFILE_FIELDS.site] || user?.site;

  if (!resolvedSite) {
    throw new SiteError("You do not have site location assigned. Go to GRID Home to configure it, then refresh this page.");
  }
  if (!resolvedSyncFields?.[SYNC_PROFILE_FIELDS.site]) {
    snackbarService.show({
      message: `Your location has been changed. Please check your settings at GRID Home.`,
      type: "error",
      duration: DURATION,
    });
  }
  const profileFieldsOrUpdatedUser = await updateProfileFields({
    client,
    user,
    email: profileEmail,
    ...resolvedSyncFields,
  });
  const syncFieldsWithResolvedSite = {
    ...resolvedSyncFields,
    [SYNC_PROFILE_FIELDS.site]: resolvedSite,
  };

  const syncNotificationProfile = async (currentUser) => {
    try {
      await syncNotificationUserProfile({
        client,
        email: profileEmail,
        user: currentUser,
        ...syncFieldsWithResolvedSite,
      });
    } catch (notificationSyncErr) {
      console.warn("Could not sync Notification User Profile site:", notificationSyncErr);
    }
  };

  if (profileFieldsOrUpdatedUser?.id) {
    const resolvedUser = { ...profileFieldsOrUpdatedUser, site: resolvedSite };
    await syncNotificationProfile(resolvedUser);
    return { user: resolvedUser };
  }
  const {
    data: { createDigitalLabBookingUserProfile },
  } = await client.mutate({
    mutation: CREATE_DIGITAL_LAB_BOOKING_USER_PROFILE,
    fetchPolicy: "no-cache",
    variables: {
      email: profileEmail,
      lastFilter: stringifyFilter(emptyLastFilter),
      ...profileFieldsOrUpdatedUser,
    },
  });

  const createdResolvedUser = { ...createDigitalLabBookingUserProfile, site: resolvedSite };
  await syncNotificationProfile(createdResolvedUser);

  return {
    user: createdResolvedUser,
  };
};

export const getSiteTimezone = async ({ client, siteName }) => {
  const result = await client.query({
    query: GET_SITE_TIMEZONE,

    variables: {
      siteName: siteName,
    },
    fetchPolicy: "no-cache",
  });

  const siteDetail = get(result, "data.getSite");
  return siteDetail;
};

export const getListOfActionTypes = async ({ client }) => {
  const result = await client.query({
    query: GET_LIST_OF_ACTION_TYPES,
    fetchPolicy: "no-cache",
  });

  return result?.data?.__type?.enumValues?.map((val) => val?.name);
};

const LoadBookingInstrumentsInfo = ({
  children,
  client,
  loadUserInfo,
  loadUserProjects,
  loadBookingInstruments,
  loadUsers,
  loadRoomList,
  loadBuildingList,
  loadAddReasonList,
  updateSearchDropDownFilter,
  loadActionTypes,
}) => {
  const infoUrl = "https://go.roche.com/grid-info-box";
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [retry, setRetry] = useState(0);
  const storeUser = useSelector((store) => store.user);
  const { widgetName } = useContext(WidgetContext);

  const clearResetAllStateOnFreshLogin = (user) => {
    const userId = user?.id;
    if (!userId) {
      markBookEquipmentStartupResetPending();
      return stringifyFilter(emptyLastFilter);
    }

    if (hasClearedResetAllForCurrentAppLoad) {
      return undefined;
    }

    clearResetAllStartupPreferences();
    markBookEquipmentStartupResetPending();
    setBookEquipmentSessionPreferences({
      lastFavFilter: DEFAULT_FILTER,
      lastDisplayColumns: DEFAULT_COLUMNS(),
    });
    hasClearedResetAllForCurrentAppLoad = true;
    return stringifyFilter(emptyLastFilter);
  };

  const openGridHomeInNewTab = () => {
    window.open(`${process.env.REACT_APP_LP_GRAPHQL_ENDPOINT_CLOUDFRONT}`, "_blank", "noopener,noreferrer");
  };
  const openInfoPageInNewTab = () => {
    window.open(`${infoUrl}`, "_blank", "noopener,noreferrer");
  };
  const refreshContext = async () => {
    await refreshSessionSafely("Session refresh on user action failed:");
    setRetry((prev) => prev + 1);
  };
  useSecondaryAuth({ client, loading });
  useEffect(() => {
    const loadData = async () => {
      setLoading(true);
      setError(null);
      try {
        await refreshSessionSafely("Session refresh before bootstrap failed:");

        const [
          { email, roles, irRole, ...syncFields },
          actionTypes,
          { bookingUsers },
          { bookingAddReason },
          { buildingList },
          { roomList },
          { items: allIrGroups },
        ] = await Promise.all([
          checkRoleAndGetUserEmail(Auth),
          getListOfActionTypes({ client }),
          getBookingUsers({
            client,
            query_bookingUsers: LIST_DIGITAL_LAB_BOOKING_USERS,
          }),
          getBookingAddReason({ client }),
          getBuildingList({ client, siteName: filterInitialState?.site }),
          getRoomList({ client, siteName: filterInitialState?.site }),
          getAllData({
            client,
            query: LIST_IR_GROUP_ADMIN_MAPPINGS,
            variables: { limit: 1000 },
            dataPath: ["data", "listIRGroupAdminMappings"],
            drillData: true,
            awsAppSyncConfig: REPO_CONFIG,
          }),
        ]);

          const { user } = await getUserDetails({ client, email, ...syncFields });
          const clearedLastFilter = clearResetAllStateOnFreshLogin(user);
        const siteName = user?.site || filterInitialState?.site;
        const isPredUser = siteName === PRED_SITE_NAME;
        const isGredUser = siteName === GRED_SITE_NAME;

        const received = await getSiteTimezone({ client, siteName });

        const { timezone } = received;
        const projects = isPredUser ? (await getUserProjects({ client, user })) : null;

        const irGroups = (allIrGroups || []).filter(
          (group) =>
            group.userIds?.some((u) => u.userId === user.user) ||
            group.reviewers?.some((r) => r.userId === user.user)
        );

        loadActionTypes(actionTypes);
        loadUsers(bookingUsers);
        loadUserInfo({
          ...user,
          ...(clearedLastFilter ? { lastFilter: clearedLastFilter } : {}),
          timezone: timezone,
          site: siteName,
          isPredUser,
          isGredUser,
          roles: roles,
          irRole,
          irGroups,
        });
        loadAddReasonList(bookingAddReason);
        loadBuildingList(buildingList);
        loadRoomList(roomList);

        if (projects) {
          loadUserProjects(projects);
        } else {
          scheduleProjectsRetry({ client, user, loadUserProjects });
        }

        const shouldLoadSearchPreferences = widgetName === undefined;
        if (shouldLoadSearchPreferences) {
          const searchPreferances = resolveSearchPreferences(user?.searchPreference);
          if (searchPreferances) {
            updateSearchDropDownFilter(searchPreferances);
          }
        }
      } catch (err) {
        const errorMessage = typeof err === 'string' ? err : err?.message || '';
        const resolvedError = errorMessage.includes(CONDITIONAL_REQUEST_FAILED_ERROR)
          ? new EmailChangedError(EMAIL_CHANGED_MESSAGE)
          : err || new Error("Unexpected error has occurred");
        console.warn(resolvedError);
        setError(resolvedError);       
      } finally {
        setLoading(false);
      }
    };
    loadData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    loadUserInfo,
    loadUserProjects,
    loadBookingInstruments,
    loadUsers,
    client,
    retry,
    loadRoomList,
    loadBuildingList,
    loadAddReasonList,
  ]);
  if (loading)
    return (
      <FullScreenCentered>
        <OwcProgressSpinner data-testid="loading" diameter={80} />
      </FullScreenCentered>
    );
  if (error !== null)
    return (
      <FullScreenCentered>
        <>
          {renderErrorMessage({ error, infoUrl, openGridHomeInNewTab, openInfoPageInNewTab })}
          <ErrorActions>
            {error?.name === "SiteError" && (
              <OwcButton variant="primary" onClick={refreshContext} data-testid="refresh-button">
                Refresh
              </OwcButton>
            )}
            {error?.name !== "SiteError" && error?.name !== "UnauthorizedError" && error?.name !== "EmailChangedError" && (
              <OwcButton variant="primary" onClick={() => setRetry(retry + 1)} data-testid="try-again-button">
                Try again
              </OwcButton>
            )}
            <OwcButton
              data-testid="signout-button"
              variant="primary"
              onClick={() => signOut(client, storeUser)}
            >
              Sign out
            </OwcButton>
          </ErrorActions>
        </>
      </FullScreenCentered>
    );
  return children;
};

export default compose(
  connect(null, {
    loadUserInfo: loadUserInfoAction,
    loadUserProjects: loadUserProjectsAction,
    loadBookingInstruments: loadBookingInstrumentsAction,
    loadUsers: loadUsersAction,
    loadRoomList: loadRoomListAction,
    loadBuildingList: loadBuildingListAction,
    loadAddReasonList: loadAddReasonListAction,
    updateSearchDropDownFilter: updateSearchDropDownFilterActions,
    loadActionTypes: loadActionTypesAction,
  }),
  withApollo
)(LoadBookingInstrumentsInfo);
